import React, { useEffect, useState } from "react";
import { Navbar, Nav, Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import { Link, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Offcanvas from "react-bootstrap/Offcanvas";
import { openSidebar, setAnnounceCount } from "../store/sidebar";
import { getUsedIconsList } from "../constants/sidebar";
import {
  getCountOfUnreadAnnouncements,
  getCountOfUnverifiedQuestions,
} from "../utils/discussions";
import { getPendingReviewCount } from "../utils/ieltsApi";
import { isEmpty } from "lodash";
import TooltipComponent from "../components/StudentDashboard/Tooltip/Tooltip";

const Sidebar = ({ isMobileView, isSecondSidebarOpen }) => {
  const dispatch = useDispatch();
  const [unverifiedCount, setUnverifiedCount] = useState(0);
  const [unreadAnnounCount, setUnreadAnnounCount] = useState(0);
  const [pendingReviewCount, setPendingReviewCount] = useState(0);

  const sidebarStates = useSelector((state) => state.sidebar);
  const isUpdateAnnouncement =
    sidebarStates.isAnnounceCount === true ? true : false;
  const isMobileSidebar = sidebarStates?.open === true ? true : false;
  const { id, classroomId } = useParams();
  const location = useLocation();
  const isMyClassrooms = location.pathname.includes("myClassrooms");

  useEffect(() => {
    if (isUpdateAnnouncement && unreadAnnounCount > 0) {
      setUnreadAnnounCount(0);
    }
  }, [isUpdateAnnouncement, unreadAnnounCount]);

  useEffect(() => {
    const handleKeydown = (event) => {
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    document.addEventListener("keydown", handleKeydown);

    return () => {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  const getUnverfiedQuestions = async (classId) => {
    try {
      const response = await getCountOfUnverifiedQuestions({
        classroomId: classId,
      });
      if (response?.count) {
        setUnverifiedCount(response?.count);
      } else {
        setUnverifiedCount(0);
      }
    } catch (error) {
      console.error("Error fetching classrooms:", error.message);
      // Handle error, show a message to the user, etc.
    }
  };

  const getUnredAnnouncementCount = async (classId) => {
    try {
      dispatch(setAnnounceCount(false));
      const response = await getCountOfUnreadAnnouncements({
        classroomId: classId,
      });
      if (response?.count) {
        setUnreadAnnounCount(response?.count);
      } else {
        setUnreadAnnounCount(0);
      }
    } catch (error) {
      console.error("Error fetching classrooms:", error.message);
      // Handle error, show a message to the user, etc.
    }
  };

  const fetchPendingReviewCount = async (classId) => {
    try {
      const response = await getPendingReviewCount(classId);
      setPendingReviewCount(response?.count || 0);
    } catch {
      setPendingReviewCount(0);
    }
  };

  useEffect(() => {
    // Check if pathname includes "myClassrooms"
    if (!isEmpty(classroomId) && isMyClassrooms) {
      getUnverfiedQuestions(classroomId);
      getUnredAnnouncementCount(classroomId);
      fetchPendingReviewCount(classroomId);
    } else if (!isEmpty(id) && isMyClassrooms) {
      getUnverfiedQuestions(id);
      getUnredAnnouncementCount(id);
      fetchPendingReviewCount(id);
    } else {
      setUnverifiedCount(0);
      setUnreadAnnounCount(0);
      setPendingReviewCount(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, classroomId]);

  const handleClose = () => {
    dispatch(openSidebar(false));
  };

  useEffect(() => {
    if (!isMobileView) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobileView]);

  const menuItems = sidebarStates?.links || [];

  return (
    <>
      {!isSecondSidebarOpen && (
        <div
          className={`${
            isMobileView ? "d-none" : "d-flex"
          } align-items-center mx-3`}
        >
          <div>
            <img
              src="/Logo.png"
              alt="Logo"
              className="sidebar-logo"
              style={{ width: "30px", height: "30px" }}
            />
          </div>
          <Navbar.Brand className="h1 text-white mx-2 my-3">
            Tutoria
          </Navbar.Brand>
        </div>
      )}
      {isSecondSidebarOpen ? (
        <Navbar
          expand="lg"
          variant="dark"
          className={`sticky-top ${isMobileView ? "d-none" : ""}`}
        >
          <Navbar.Toggle aria-controls="basic-navbar-nav"></Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className={`mr-auto flex-column`}>
              <div className="d-flex justify-content-center align-items-center my-3">
                <img
                  src="/Logo.png"
                  alt="Logo"
                  className="sidebar-logo"
                  style={{ width: "30px", height: "30px" }}
                />
              </div>
              {menuItems?.map(
                (item) =>
                  item.icon && (
                    <MenuItem
                      unverifiedCount={unverifiedCount}
                      unreadAnnounCount={unreadAnnounCount}
                      pendingReviewCount={pendingReviewCount}
                      className="my-3"
                      {...item}
                      key={item.id}
                      isMobileView={isMobileView}
                      isSecondSidebarOpen={isSecondSidebarOpen}
                    />
                  ),
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      ) : (
        <Navbar
          expand="lg"
          variant="dark"
          className={`${isMobileView ? "d-none" : ""}`}
        >
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className={`mr-auto flex-column w-100`}>
              {menuItems?.map((item) => (
                <MenuItem
                  unverifiedCount={unverifiedCount}
                  unreadAnnounCount={unreadAnnounCount}
                  pendingReviewCount={pendingReviewCount}
                  key={item.id}
                  isMobileView={isMobileView}
                  {...item}
                />
              ))}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      )}
      <div className="mobile-view-sidebar-styles">
        <Offcanvas show={isMobileSidebar} onHide={handleClose}>
          <Offcanvas.Header>
            <Offcanvas.Title>
              <img
                src="/Logo.png"
                alt="Logo"
                className="sidebar-logo"
                style={{ marginRight: "6px", width: "30px", height: "30px" }}
              />
              Tutoria
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className={`mr-auto flex-column w-100`}>
              {menuItems?.map((item) => (
                <MenuItem
                  unverifiedCount={unverifiedCount}
                  unreadAnnounCount={unreadAnnounCount}
                  pendingReviewCount={pendingReviewCount}
                  key={item.id}
                  isMobileView={isMobileView}
                  {...item}
                  handleClose={handleClose}
                />
              ))}
            </Nav>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
      {/* Responsive font size for sidebar menu text */}
      <style>{`
        @media (max-width: 1024px) {
          .sidebar-menu-text {
            font-size: 12px !important;
          }
          .sidebar-logo {
            width: 22px !important;
            height: 22px !important;
          }
        }
      `}</style>
    </>
  );
};

const MenuItem = ({
  icon,
  text,
  isHeading,
  unverifiedCount = 0,
  unreadAnnounCount = 0,
  pendingReviewCount = 0,
  isMobileView,
  isDropdown,
  dropdownItems,
  link,
  isSecondSidebarOpen,
  key,
  handleClose = () => {},
  selected = false,
}) => {
  const itemClass = "heading";
  const isIconOnly = isHeading && isMobileView;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const isDiscussion = text === "Discussions";
  const isAnnouncement = text === "Announcements";
  const isReviewAttempts = text === "Review Attempts";
  const sidebarStates = useSelector((state) => state.sidebar);

  const handleMouseEnter = () => {
    if (!isMobileView) {
      setIsDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobileView) {
      setIsDropdownOpen(false);
    }
  };

  function truncateText(text, maxLength) {
    if (text?.length > maxLength) {
      return text?.substring(0, maxLength) + "...";
    }
    return text;
  }

  return (
    <>
      {isHeading && !isSecondSidebarOpen && <hr />}
      {isDropdown ? (
        <Dropdown
          data-bs-theme="dark"
          as={Nav.Item}
          className={`position-relative ${itemClass}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          key={key}
        >
          <Dropdown.Toggle
            as={Link}
            to={link}
            className={`${
              selected && !isSecondSidebarOpen ? "selected-sidebar-link" : ""
            } navlink-styles w-100 d-flex align-items-center justify-content-between sidebar-item nav-link ${
              isIconOnly && "icon-only"
            }`}
            style={{
              textDecoration: "none",
              color: selected ? "white" : "#77808e",
            }}
            onKeyDown={() => {}}
          >
            <div
              className={`d-flex align-items-center`}
              style={{ marginRight: "8px" }}
            >
              <div style={{ width: "24px" }}>
                {icon && !sidebarStates?.visible && (
                  <img
                    src={`/${icon}.svg`}
                    alt={text}
                    className="w-6 h-6 position-relative"
                  />
                )}
                {icon &&
                  sidebarStates?.visible &&
                  getUsedIconsList(selected ? { color: "white" } : {}, icon)}
              </div>
              {isMobileView && isHeading && !isIconOnly ? null : (
                <div className={`text-sm ${icon && "mx-2"}`}>
                  {truncateText(text, 15)}
                </div>
              )}
            </div>
            <img src="/Up.svg" alt="Arrow" className="custom-arrow" />
          </Dropdown.Toggle>

          <Dropdown.Menu
            show={isDropdownOpen}
            style={{
              position: "relative",
              top: "100%",
              left: "0",
              background: "transparent",
              border: "none",
            }}
          >
            {dropdownItems?.length > 0 &&
              dropdownItems?.map((item) => (
                <Dropdown.Item
                  style={{ background: "transparent", paddingLeft: "40px" }}
                  key={item.id}
                  data-id={item.id}
                >
                  <Link
                    to={item.link}
                    style={{
                      textDecoration: "none",
                      color: selected ? "white" : "#77808e",
                    }}
                    className={`nav-link navlink-styles ${
                      selected && !isSecondSidebarOpen
                        ? "selected-sidebar-link"
                        : ""
                    }`}
                  >
                    {truncateText(item?.text, 15)}
                  </Link>
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <Nav.Item className={`position-relative ${itemClass}`}>
          <Link
            to={link}
            className={`navlink-styles ${
              selected && !isSecondSidebarOpen ? "selected-sidebar-link" : ""
            } w-100 sidebar-item nav-link ${isIconOnly && "icon-only"}`}
            style={{
              textDecoration: "none",
              color: selected ? "white" : "#77808e",
            }}
            onClick={handleClose}
            onKeyDown={(event) => {}}
          >
            <div className={`d-flex align-items-center`}>
              <div style={{ width: "24px" }}>
                {icon && !sidebarStates?.visible && (
                  <img
                    src={`/${icon}.svg`}
                    alt={text}
                    className="w-6 h-6 position-relative"
                  />
                )}
                {icon &&
                  sidebarStates?.visible &&
                  getUsedIconsList(selected ? { color: "white" } : {}, icon)}
              </div>
              {(isMobileView && isHeading && !isIconOnly) ||
              isSecondSidebarOpen ? null : (
                <div
                  className={`sidebar-menu-text text-sm ${icon && "mx-2"}`}
                  style={{
                    fontSize: "14px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "-webkit-fill-available",
                  }}
                >
                  {(isDiscussion && unverifiedCount > 0) ||
                  (isAnnouncement && unreadAnnounCount > 0) ||
                  (isReviewAttempts && pendingReviewCount > 0) ? (
                    <div
                      style={{
                        height: "25px",
                        alignContent: "center",
                      }}
                    >
                      {text}
                    </div>
                  ) : (
                    text
                  )}
                  {(isDiscussion && unverifiedCount > 0) ||
                  (isAnnouncement && unreadAnnounCount > 0) ||
                  (isReviewAttempts && pendingReviewCount > 0) ? (
                    <TooltipComponent
                      direction="top"
                      TooltipText={
                        isReviewAttempts && pendingReviewCount > 0
                          ? "Pending reviews"
                          : isAnnouncement && unreadAnnounCount > 0
                            ? "Unread announcements count"
                            : "Unverified questions count"
                      }
                    >
                      <span
                        className={
                          selected ? "sel-discussion-color" : "discussion-color"
                        }
                        style={{
                          backgroundColor: selected ? "white" : "#4403bf",
                          color: selected ? "#4403bf" : "white",
                          width: "25px",
                          borderRadius: "100%",
                          height: "25px",
                          textAlign: "center",
                          placeContent: "center",
                        }}
                      >
                        {isReviewAttempts && pendingReviewCount > 0
                          ? pendingReviewCount
                          : isAnnouncement && unreadAnnounCount > 0
                            ? unreadAnnounCount
                            : unverifiedCount}
                      </span>
                    </TooltipComponent>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          </Link>
        </Nav.Item>
      )}
    </>
  );
};

MenuItem.propTypes = {
  icon: PropTypes.string,
  link: PropTypes.string,
  text: PropTypes.string.isRequired,
  isHeading: PropTypes.bool,
  isMobileView: PropTypes.bool,
  isDropdown: PropTypes.bool,
  dropdownItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
  onClick: PropTypes.func,
  isSecondSidebarOpen: PropTypes.bool,
};

Sidebar.propTypes = {
  isMobileView: PropTypes.bool,
};

export default Sidebar;
